module.exports = __webpack_public_path__ + "img/bookshelf17.a1f5af24.jpg";